export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-mobile-1.0.0',
    name: 'JDSDatepickerMobileInternal'
  },
  hierarchy: {
    container: [
      {
        'top-container': ['left-jds_button', 'close-jds_button']
      },
      {
        'controls-container': [
          'jds_datepicker_header',
          'top-jds_divider',
          'jds_datepicker_calendar',
          'jds_datepicker_month_view',
          'jds_datepicker_year_view'
        ]
      },
      {
        'confirmation-container': [
          'bottom-jds_divider',
          {
            'confirmation-group-container': [
              'confirm-jds-text',
              'confirm-jds_button'
            ]
          }
        ]
      }
    ]
  },
  base: {
    container: {
      'background-color': '{primaryBackground}',
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.center}',
      size: '{size.max}',
      'translate-y': '{size.max}',
      transition: {
        property: ['translate-y'],
        duration: '{rapid}',
        'timing-function': '{easeQuick}'
      }
    },
    'top-container': {
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.end}',
      'align-items': '{alignItems.center}',
      'padding-top': '{xs}',
      'padding-bottom': '{xs}',
      'padding-left': '{s}',
      'padding-right': '{s}',
      width: '{size.max}'
    },
    'left-jds_button': {
      hidden: true,
      kind: 'tertiary',
      icon: 'ic_back',
      size: 'medium'
    },
    'close-jds_button': {
      kind: 'tertiary',
      icon: 'ic_close',
      size: 'medium'
    },
    'controls-container': {
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.center}',
      gap: '{m}',
      flex: 1
    },
    jds_datepicker_header: {
      state: 'default',
      'padding-left': '{s}',
      'padding-right': '{s}'
    },
    'top-jds_divider': {
      pad: 'none',
      orientation: 'horizontal',
      hidden: true
    },
    jds_datepicker_calendar: {
      hidden: false,
      'padding-left': '{s}',
      'padding-right': '{s}',
      'padding-bottom': '{m}'
    },
    jds_datepicker_month_view: {
      hidden: true,
      'padding-left': '{s}',
      'padding-right': '{s}'
    },
    jds_datepicker_year_view: {
      hidden: true,
      'padding-left': '{s}',
      'padding-right': '{s}'
    },
    'confirmation-container': {
      'padding-top': 0,
      'padding-bottom': '{m}',
      'flex-direction': '{flexDirection.column}',
      gap: '{s}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.center}',
      width: '{size.max}'
    },
    'bottom-jds_divider': {
      pad: 'none',
      orientation: 'horizontal'
    },
    'confirmation-group-container': {
      'padding-top': 0,
      'padding-right': '{m}',
      'padding-bottom': 0,
      'padding-left': '{m}',
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.center}',
      gap: '{s}',
      width: '{size.max}'
    },
    'confirm-jds_button': {
      fullWidth: true,
      kind: 'primary',
      size: 'medium'
    },
    'confirm-jds-text': {
      'font-family': '{text_137}',
      color: '{text_21}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    state: {
      month_view: {
        'top-jds_divider': {
          hidden: false
        },
        'top-container': {
          'justify-content': '{justifyContent.spaceBetween}'
        },
        'left-jds_button': {
          hidden: false
        },
        jds_datepicker_calendar: {
          hidden: true
        },
        jds_datepicker_month_view: {
          hidden: false
        },
        jds_datepicker_header: {
          state: 'month',
          showArrows: false
        }
      },
      year_view: {
        'top-jds_divider': {
          hidden: false
        },
        'top-container': {
          'justify-content': '{justifyContent.spaceBetween}'
        },
        'left-jds_button': {
          hidden: false
        },
        jds_datepicker_calendar: {
          hidden: true
        },
        jds_datepicker_year_view: {
          hidden: false
        },
        jds_datepicker_header: {
          state: 'year',
          showArrows: false
        }
      }
    },
    open: {
      true: {
        container: {
          'translate-y': 0
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      state: {
        values: ['default', 'month_view', 'year_view']
      },
      open: {
        values: [false, true]
      }
    },
    data: {
      jds_datepicker_header: {
        month: {
          type: 'string',
          name: 'monthName'
        },
        year: {
          type: 'string',
          name: 'year'
        },
        showArrows: {
          type: 'boolean',
          name: 'showArrows'
        },
        yearSelectable: {
          type: 'boolean',
          name: 'yearSelectable'
        },
        monthSelectable: {
          type: 'boolean',
          name: 'monthSelectable'
        }
      },
      jds_datepicker_month_view: {
        months: {
          type: 'list',
          name: 'months',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        }
      },
      jds_datepicker_year_view: {
        current: {
          type: 'number',
          name: 'current'
        },
        data: {
          type: 'object',
          name: 'yearData',
          object: {
            count: 'number',
            disabled: 'list',
            min: 'number',
            max: 'number'
          }
        },
        loadedYears: {
          type: 'list',
          name: 'loadedYears',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        }
      },
      jds_datepicker_calendar: {
        day: {
          type: 'number',
          name: 'date'
        },
        month: {
          type: 'number',
          name: 'month'
        },
        year: {
          type: 'number',
          name: 'year'
        },
        selected: {
          type: 'date',
          name: 'value'
        },
        disabled: {
          type: 'object',
          name: 'calendarData',
          object: {
            disabledDays: 'list',
            disabledDates: 'list',
            max: 'date',
            min: 'date'
          }
        },
        days: {
          type: 'JDSDatepickerCalendarHeader.days',
          name: 'calendarDays'
        },
        rows: {
          type: 'JDSDatepickerCalendar.rows',
          name: 'calendarRows'
        }
      },
      'confirm-jds_button': {
        label: {
          type: 'string',
          name: '_confirmLabel'
        }
      },
      'confirm-jds-text': {
        value: {
          type: 'string',
          name: 'confirmDate'
        }
      }
    },
    events: {
      'left-jds_button': {
        onClick: '_onBack'
      },
      'close-jds_button': {
        onClick: 'onClose'
      },
      jds_datepicker_header: {
        onMonthClick: '_onMonthClick',
        onYearClick: '_onYearClick',
        onPrev: '_onPrev',
        onNext: '_onNext'
      },
      jds_datepicker_month_view: {
        onSelect: '_onMonthSelect'
      },
      jds_datepicker_year_view: {
        onSelect: '_onYearSelect'
      },
      jds_datepicker_calendar: {
        onSelect: '_onSelect',
        onSwipeLeft: '_onNextCalendar',
        onSwipeRight: '_onPrevCalendar'
      },
      'confirm-jds_button': {
        onClick: 'onConfirm'
      }
    },
    a11y: {
      'left-jds_button': {
        properties: {
          ariaLabel: {
            name: 'previousButtonAriaLabel',
            value: 'Tap to Return'
          }
        }
      },
      'close-jds_button': {
        properties: {
          ariaLabel: {
            name: 'closeAriaLabel',
            value: 'Tap to Close'
          }
        }
      },
      jds_datepicker_header: {
        properties: {
          previousAriaLabel: 'previousMonthAriaLabel',
          nextAriaLabel: 'nextMonthAriaLabel'
        }
      },
      'confirm-jds_button': {
        properties: {
          ariaLabel: {
            name: 'confirmAriaLabel',
            value: 'Tap to Confirm'
          }
        }
      }
    }
  }
};
